import { lazy } from "react";

/**
 * Wraps React.lazy with a single retry on failure.
 * Handles transient QUIC/network failures that cause chunk loads to return
 * HTML (Firebase Hosting SPA fallback) instead of JS.
 */
export function lazyRetry(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  importFn: () => Promise<{ default: React.ComponentType<any> }>
) {
  return lazy(() =>
    importFn().catch(() => {
      // Retry once — handles transient QUIC/network failures
      return importFn();
    })
  );
}
